<template>
  <div class="w-full h-full" >
    <div v-if="loaded" class="flex flex-col mb-4 mt-4 items-baseline">

      <div class="flex flex-row items-baseline justify-between w-full">
        <div class="flex flex-row items-baseline">
          <div class="flex flex-row space-x-2 items-baseline ">
            <div class="justify-self-start text-2xl  font-semibold " :class="[colorPalette.importantText]">{{ dataset.newCustomers.currentAmount}} </div>
            <div class="text-lg">{{ dataset.newCustomers.label}}</div>
          </div>
          <span class="ml-2  text-sm font-medium text-gray-500">(versus {{dataset.newCustomers.lastPeriodAmount}})</span>
        </div>
        <div>
          <div v-if="dataset.newCustomers.periodPercentage > 0" class="justify-self-end ">
            <div class="inline-flex items-baseline px-3 pt-3 w-28 rounded-full text-sm font-medium bg-green-100 text-green-800">
              <!-- Heroicon name: solid/arrow-sm-up -->
              <svg class="-ml-1 mr-0.5 -mt-3 flex-shrink-0 self-center h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              <div class="-mt-2.5">{{( dataset.newCustomers.periodPercentage).toFixed(2)}} %</div>
            </div>
          </div>
          <div v-else-if="dataset.newCustomers.periodPercentage < 0" class="justify-self-end ">
            <div class="inline-flex items-baseline px-3 pt-3 w-28 rounded-full text-sm font-medium bg-red-100 text-red-800">
              <!-- Heroicon name: solid/arrow-sm-up -->
              <svg class="-ml-1 mr-0.5 -mt-3 flex-shrink-0 self-center h-5 w-5 text-red-500"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"/>
              </svg>
              <div class="-mt-2.5">{{( dataset.newCustomers.periodPercentage).toFixed(2)}} %</div>
            </div>
          </div>
          <div v-else class="justify-self-end ">
            <div class="inline-flex items-baseline px-3 pt-3 w-28 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
              <!-- Heroicon name: solid/arrow-sm-up -->
              <svg class="-ml-2 -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                      d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                      clip-rule="evenodd"/>
              </svg>
              <svg class="-ml-3 mr-1 -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clip-rule="evenodd"/>
              </svg>
              <div class="-mt-2.5">{{( dataset.returningCustomers.periodPercentage).toFixed(2)}} %</div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-baseline justify-between w-full">
        <div class="flex flex-row items-baseline">
          <div class="flex flex-row space-x-2 items-baseline col-span-2">
            <div class="justify-self-start text-2xl  font-semibold " :class="[colorPalette.importantText]">{{ dataset.returningCustomers.currentAmount}} </div>
            <div class="text-lg">{{ dataset.returningCustomers.label}}</div>
          </div>
          <span class="ml-2 text-sm font-medium text-gray-500">(versus {{ dataset.returningCustomers.lastPeriodAmount}})</span>
        </div>
        <div>
          <div v-if="dataset.returningCustomers.periodPercentage > 0" class="justify-self-end ">
            <div class="inline-flex items-baseline px-3 pt-3 w-28  rounded-full text-sm font-medium bg-green-100 text-green-800">
              <!-- Heroicon name: solid/arrow-sm-up -->
              <svg class="-ml-1 mr-0.5 -mt-3 flex-shrink-0 self-center h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              <div class="-mt-2.5">{{( dataset.returningCustomers.periodPercentage).toFixed(2)}} %</div>
            </div>
          </div>
          <div v-else-if="dataset.returningCustomers.periodPercentage < 0" class="justify-self-end ">
          <div class="inline-flex items-baseline px-3 pt-3 w-28 rounded-full text-sm font-medium bg-red-100 text-red-800">
            <!-- Heroicon name: solid/arrow-sm-up -->
            <svg class="-ml-1 mr-0.5 -mt-3 flex-shrink-0 self-center h-5 w-5 text-red-500"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"/>
            </svg>
            <div class="-mt-2.5">{{( dataset.returningCustomers.periodPercentage).toFixed(2)}} %</div>
          </div>
        </div>
          <div v-else class="justify-self-end ">
          <div class="inline-flex items-baseline px-3 pt-3 w-28 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
            <!-- Heroicon name: solid/arrow-sm-up -->
            <svg class="-ml-2 -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                    d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                    clip-rule="evenodd"/>
            </svg>
            <svg class="-ml-3 mr-1 -mt-3 flex-shrink-0 self-center h-5 w-5 text-gray-500"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"/>
            </svg>
            <div class="-mt-2.5">{{( dataset.returningCustomers.periodPercentage).toFixed(2)}} %</div>
          </div>
        </div>
        </div>
      </div>

    </div>
    <canvas class=" mb-28 " ref="stackedBar" ></canvas>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import Chart from "chart.js/auto";
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'
import ApiService from "@/services/ApiService";
let apiService = new ApiService;

const fullConfig = resolveConfig(tailwindConfig);
let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let data = ref(Object);
let loaded = ref(false);
let dataset = ref(Object);
let stackedBar = ref();

let chart = ref(null)

onMounted ( async () => {
  let apiData = await apiService.get(props.source);
  data.value = apiData.data;
  dataset.value = data.value.datasets;
  chart.value = new Chart(stackedBar.value, fillData(data.value, props.style, props.colorPalette.barGraphPrimary,props.colorPalette.barGraphSecondary ))
  loaded.value = true;
  }
)

function fillData(data, style, primaryColor, secondaryColor)
{
  return {
    type: "bar",
    data: {
      labels: data.labels,
      datasets: [
        {
          label: capitalize(data.datasets.returningCustomers.label),
          backgroundColor: fullConfig.theme.colors['' + primaryColor],
          data: data.datasets.returningCustomers.data,
        },
        {
          label: capitalize(data.datasets.newCustomers.label),
          backgroundColor: fullConfig.theme.colors['' + secondaryColor],
          data: data.datasets.newCustomers.data,
          borderRadius: 8
        }
      ],
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      plugins:{
        legend: {
          position:'bottom',
          labels:{
            font:{
              size:16,
            }
          }
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          stacked: true,
        },
        y: {
          stacked: true,
        },
      }
    },
  }
}

function capitalize(word)
{
  return word.charAt(0).toUpperCase() + word.slice(1);
}
</script>



